import {
  ExtendedCardDTO,
  RegisterTransactionDTO,
  TransactionDTO,
} from "../generated/api";
import { isNRID, isPNR, isSNR } from "./identity-validators";
import { checkRnr } from "./rnr-validitators";

export function isNumber(string: any) {
  return /^\d+$/.test(string);
}

export function isCorrectCardNumber(string: any){
  return /^[a-zA-Z0-9]+$/.test(string);
}

export function overChargingTransactions(
  extendedCard: ExtendedCardDTO,
  transactions: TransactionDTO[]
) {
  let amount = 0;
  for (let i = 0; i < transactions.length; i++) {
    let add = transactions[i]?.amount;
    if (add) {
      amount += add;
    }
  }
  const amountToLimit = extendedCard?.amountToLimit;

  return amount && amountToLimit && amount > amountToLimit;
}

export function transactionsAlreadyExists(
  extendedCard: ExtendedCardDTO,
  transactions: TransactionDTO[]
) {
  let transactionWarningIndex: number[] = [];
  for (let i = 0; i < transactions.length; i++) {
    if (transactionAlreadyExists(extendedCard, transactions[i])) {
      transactionWarningIndex.push(i);
    }
  }
  return transactionWarningIndex;
}

export function validateMissingCareInfo(transactions: TransactionDTO[]){
  let warningIndex: number[] = [];
  for (let i = 0; i < transactions.length; i++) {
    if (!transactions[i].careProvider || !transactions[i].careUnit) {
      warningIndex.push(i);
    }
  }
  return warningIndex;
}

export function overChargingTransaction(
  extendedCard: ExtendedCardDTO,
  transaction: RegisterTransactionDTO
) {
  const amount = transaction?.amount;
  const amountToLimit = extendedCard?.amountToLimit;
  return amount !== undefined && amountToLimit !== undefined && amount > amountToLimit;
}

export function transactionAlreadyExists(
  extendedCard: ExtendedCardDTO,
  transaction: RegisterTransactionDTO
) {
  const amount = transaction?.amount;
  const date = transaction?.transactionDate;
  const transactions = extendedCard?.transactions;
  return (
    transactions &&
    transactions.some(
      (trans: TransactionDTO) =>
        trans.status === "ACTIVE" &&
        // eslint-disable-next-line
        trans?.amount == amount &&
        // eslint-disable-next-line
        date?.toLocaleDateString() ===
          trans.transactionDate?.toLocaleDateString()
    )
  );
}

export function lookupDefaultFormatsValidator(value: any, patterns: string[]) {
  const inputLength = value.length;
  if (!inputLength) {
    return false;
  }
  const stripped = value.replace("-", "");
  if (isPNR(stripped)) {
    return true;
  } else if (checkRnr(value, patterns)) {
    return true;
  } else if (isNRID(stripped) || isSNR(stripped)) {
    return true;
  } else {
    return false;
  }
}

export function formatInput(input: any) {
  const stripped = input.replace("-", "");
  if (isPNR(stripped)) {
    return formatPNR(stripped);
  } else {
    return input;
  }
}

export function formatPNR(input: any) {
  let format;
  if (input.length < 12) {
    const year = new Date().getFullYear() - 2000;
    if (input.includes("+")) {
      format = input.replace("+", "");
      format = "19" + format;
      return format;
    } else if (parseInt(input.substring(0, 2)) < year) {
      format = "20" + input;
      return format;
    } else {
      format = "19" + input;
      return format;
    }
  }
  return input;
}

export const checkTransactions = (card: any) => {
  if (card !== null) {
    let flag = false;
    const transactions = card.transactions;
    transactions.forEach((transaction: any) => {
      if (transaction.status === "ACTIVE") {
        flag = true;
      }
    });
    return flag;
  }
};

export const validateDateFormat = (input: any) => {
  const pattern = new RegExp(
    "^20[0-9][0-9]-((0[1-9])|(1[0-2]))-([0-2][0-9]|3[0-1])$"
  );
  if (input !== null) {
    return pattern.test(input.toLocaleDateString("sv"));
  } else {
    return false;
  }
};
